import { match } from "ts-pattern";

import { Enum_Componententriessmartphoneentry_Category } from "graphql.d";
import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { AvailableProduct } from "shared/product/ProductSection/ProductSpecifications/AvailableProduct";
import { ComingSoonProduct } from "shared/product/ProductSection/ProductSpecifications/ComingSoonProduct";
import { LegacyProduct } from "shared/product/ProductSection/ProductSpecifications/LegacyProduct";
import { VerticalSeparator } from "ui/VerticalSeparator";

const CatalogCategory = Enum_Componententriessmartphoneentry_Category;

export const ProductSpecifications = () => {
  const { family } = useProductPageContext();

  return (
    <div className="lg:flex lg:w-480">
      <VerticalSeparator className="hidden lg:block lg:h-full" />
      {match(family?.category)
        .with(CatalogCategory.Legacy, () => <LegacyProduct />)
        .with(CatalogCategory.ComingSoon, () => <ComingSoonProduct />)
        .otherwise(() => (
          <AvailableProduct />
        ))}
    </div>
  );
};
